export default __webpack_public_path__ + "static/media/notify.d17c791a.png";